<div class="payment-plan">
    <table class="table mt-3">
        <thead>
        <tr>
            <th>Invoice</th>
            <th>Active</th>
            <th>Due</th>
            <th>Original Amt.</th>
            <th>Amt. Remaining</th>
        </tr>
        </thead>
        <tbody>
        <!--suppress HtmlUnknownAttribute -->
        <ng-template [ngForOf]="charges"
                     let-charge
                     ngFor>
            <tr>
                <td>{{ charge.title }}</td>
                <td>{{ charge.activeAfter | legfiDate:'MM/DD/YYYY' }}</td>
                <td>{{ charge.paymentDueOn | legfiDate:'MM/DD/YYYY' }}</td>
                <td>{{ charge.chargeAmount | legfiCurrency:'USD':'symbol':'.2' }}</td>
                <td>{{ charge.balance | legfiCurrency:'USD':'symbol':'.2' }}</td>
            </tr>
        </ng-template>
        </tbody>
    </table>

    <div class="row add-gray add-border mr-0 ml-0">
        <div class="col-md-3 offset-md-3 col-sm-6">
            <div class="form-group">
                <label>
                    Balance to Split
                </label>
                <lf-currency (ngModelChange)="updateSplitBalance($event, true)"
                             [ngModel]="splitBalance"
                             [required]="true"
                             [showSymbol]="true"
                             ngDefaultControl></lf-currency>
            </div>
        </div>

        <div class="col-md-3 col-sm-6">
            <div class="form-group">
                <label>
                    # of Split Invoices
                </label>
                <input (ngModelChange)="updateSplitCount($event);"
                       [ngModel]="splitCount"
                       class="form-control"
                       min="2"
                       required
                       type="number"/>
            </div>
        </div>
    </div>

    <div *ngIf="splitCount > 0 && splitCharges.length"
         class="add-border">
        <div class="add-gray">
            <!--suppress HtmlUnknownAttribute -->
            <ng-template [ngForOf]="splitCharges"
                         let-i="index"
                         let-split
                         ngFor>
                <div class="grid-layout grid-4">
                    <div>
                        <div class="larger text-muted">Payment #{{ i + 1 }}</div>
                    </div>

                    <div class="form-group">
                        <label>
                            Bill:
                        </label>
                        <lf-currency [(ngModel)]="split.chargeAmount"
                                     [required]="true"
                                     [showSymbol]="true"
                                     ngDefaultControl
                        ></lf-currency>
                    </div>

                    <div class="form-group">
                        <label>
                            <span>Active: </span>
                        </label>
                        <input
                            (click)="activeAfter.open()"
                            [matDatepicker]="activeAfter"
                            class="form-control date d-inline-block"
                            color="accent"
                            [(ngModel)]="split.activeAfter"
                            placeholder="Active Date"
                        />
                        <mat-datepicker #activeAfter></mat-datepicker>
                    </div>

                    <div class="form-group">
                        <label>
                            <span>Due: </span>
                        </label>
                        <input
                            (click)="paymentDueOnDatepicker.open()"
                            [matDatepicker]="paymentDueOnDatepicker"
                            class="form-control date d-inline-block"
                            color="accent"
                            [(ngModel)]="split.paymentDueOn"
                            [min]="split.activeAfter"
                            placeholder="Due Date"
                        />
                        <mat-datepicker #paymentDueOnDatepicker></mat-datepicker>
                    </div>
                </div>
                <ng-container *ngIf="i === 0 && split.paymentDueOn && split.activeAfter">
                    <div class="row mb-0">
                        <div class="col-12 d-flex justify-content-center">
                            <label>
                                Quick Set
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">
                            <button (click)="setMonthlySchedule()" class="btn btn-outline-secondary">
                                Monthly
                            </button>
                            <button (click)="setQuarterlySchedule()" class="btn btn-outline-secondary">
                                Quarterly
                            </button>
                            <button (click)="setBiannualSchedule()" class="btn btn-outline-secondary">
                                Bi-Annually
                            </button>
                            <button (click)="setYearlySchedule()" class="btn btn-outline-secondary">
                                Annually
                            </button>
                        </div>
                    </div>
                </ng-container>
            </ng-template>
        </div>

        <div class="add-pad">
            <div class="row">
                <div class="col">
                    <label>Late Fee (optional):</label>

                    <div class="form-inline">
                        <span class="mr-2">Apply</span>
                        <lf-currency [(ngModel)]="lateFee.fee"
                                     [showSymbol]="true"
                                     class="mr-2"
                                     ngDefaultControl></lf-currency>
                        <span class="mr-2">late fee to each payment if not paid within</span>
                        <input [(ngModel)]="lateFee.days"
                               class="form-control mr-2"
                               min="0"
                               style="width: 50px;"
                               type="number"/>
                        <span class="mr-2">day(s) of due date.</span>
                    </div>
                    <div class="mt-2 w-25">
                        <label>Late Fee Category</label>
                        <app-category-select [showExpenseCategories]="false"
                                             [showEquities]="false"
                                             [showAssets]="false"
                                             [showLiabilities]="false"
                                             [controlName]="'lateFeeCategory'">
                        </app-category-select>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="w-100 d-flex justify-content-end add-pad">
        <button (click)="splitPayments();"
                class="btn btn-primary add-button px-4">Create Payment Plan
        </button>
    </div>
</div>
